<template>
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'MAKLUMAT TERNAKAN'" >
  
  <br>
  <div class="w-table-wrap" style="max-height: 400px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <div class="table-profil-scrol">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-center" width="1%">BIL</th>
              <th class="w-table__header  text-center">NO KES AI</th>
              <th class="w-table__header  text-center">ID | NAMA INDUK</th>
              <th class="w-table__header  text-center">TARIKH LAHIR</th>
              <th class="w-table__header  text-center">ANAK JANTAN</th>
              <th class="w-table__header  text-center">ANAK BETINA</th>
              <th class="w-table__header  text-center">JUMLAH</th>
              <th class="w-table__header  text-center">PAPAR</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="ternakan_list.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-center" colspan="8"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan_list">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.no_kes}}</td>
                <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.ternakan_nama}}</td>
                <td class="w-table__cell text-center" style="margin:5px;"><div style="width: 110px"></div>{{$zutil.dateformat(dt.tarikh_lahir_anak)}}</td>
                <td class="w-table__cell text-center" style="margin:5px;">{{dt.jantan_anak}}</td>
                <td class="w-table__cell text-center" style="margin:5px;">{{dt.betina_anak}}</td>
                <td class="w-table__cell text-center" style="margin:5px;">{{dt.jumlah_anak}}</td>
                <td class="w-table__cell text-center" style="margin:5px;">
                  <w-tooltip md top color="white" bg-color="black" v-if="dt.lkp_status_id == null">
                      <template #activator="{ on }">
                        <w-button class="mr2" v-on="on" bg-color="warning" @click="getBeranak(dt, 3)"><div style="width: 8px"></div> 
                            <w-icon md class="mr2">fal fa-pencil</w-icon>
                       </w-button>
                      </template>
                     Beranak
                  </w-tooltip> &nbsp;
                  <w-tooltip md top color="white" bg-color="black" v-if="dt.jumlah_anak > 0">
                      <template #activator="{ on }">
                        <w-button class="mr2" v-on="on" bg-color="primary" @click="getPapar(dt, 3)"><div style="width: 8px"></div> 
                            <w-icon md class="mr2">fal fa-pencil</w-icon>
                       </w-button>
                      </template>
                     Papar
                  </w-tooltip> &nbsp;

                </td>
               
              </tr>
            </template>
          </tbody>
        </table>
        </div>
    </w-form>
  </div>
  <w-flex justify-end class="mt2">
    <template v-if="datas.lkp_status_id==40 && tamat == 1">
       <w-button class="mr2" bg-color="success" @click="sahkan(18)">
          <w-icon m class="mr2">fal fa-check-circle</w-icon>SELESAI
       </w-button>
    </template>
  </w-flex>
  </w-card>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.sinkronisasi_ai',
      form : {},
      cek_tarikh_pemeriksaan: false,
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      ternakan_list:[],
      list_stock:[],
      tamat : 1,
      bunting:[
        {value: 1, label: "BUNTING"},
        {value: 2, label: "TIDAK BUNTING"}
      ],
      kaedah_pemeriksaan: [],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => value !== '' || !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      total_harga:0,
      
      
    }
  },
  methods:{
    getBeranak(item){
      this.$inertia.visit(window.route('art.anak.form', item.id));
    },
    getPapar(item){
      this.$inertia.visit(window.route('art.anak.show', item.id));
    },
    getTarikhJangkaan(dt, usia_bunting_art){

      if(dt.bunting_art==1){
        const bunting_ternakan = this.datas.bunting_ternakan;
        const tarikh_pemeriksaan_art = new Date(this.datas.tarikh_pemeriksaan_art);

        dt.jankaan_kelahiran_art = this.calculateDueMonth(tarikh_pemeriksaan_art, bunting_ternakan, usia_bunting_art); 
      }else{
         dt.jankaan_kelahiran_art=null;
        dt.usia_bunting_art =0;
      }
    },
      sahkan(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(this.datas.id > 0){
            this.datas.lkp_status_id = item;
            this.datas.peternak = 1;
          this.$zcomm.update('art.semakan.ai-aiman.update', this.datas.id, this.datas)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.reload();
              })
              .catch(err => {

              })
              .finally(() => {
                
                this.$inertia.visit(this.$page.url)
              });
          }
        }else{ this.loading = false;}

        }) 
      },
    getTernakan(){
      // ternakan list
      for (var b in this.datas.ternakan_list) {
        if(this.datas.ternakan_list[b].bunting_art==1||this.datas.ternakan_list[b].bunting==1){
          if(this.datas.ternakan_list[b].jumlah_anak == 0){
            this.tamat = 0;
          }
          this.ternakan_list.push({
            id:this.datas.ternakan_list[b].id,
            art_id:this.datas.ternakan_list[b].art_id,
            bil_straw:this.datas.ternakan_list[b].bil_straw,
            bunting:this.datas.ternakan_list[b].bunting,
            harga_straw:this.datas.ternakan_list[b].harga_straw,
            id_ternakan:this.datas.ternakan_list[b].id_ternakan,
            jankaan_kelahiran:this.datas.ternakan_list[b].jankaan_kelahiran,
            lkpBerahi_keterangan:this.datas.ternakan_list[b].lkpBerahi_keterangan,
            lkp_berahi_id:this.datas.ternakan_list[b].lkp_berahi_id,
            no_kes:this.datas.ternakan_list[b].no_kes,
            se_stock_id:this.datas.ternakan_list[b].se_stock_id,
            skor_badan:this.datas.ternakan_list[b].skor_badan,
            status:this.datas.ternakan_list[b].status,
            ternakan_id:this.datas.ternakan_list[b].ternakan_id,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            list_stock: this.datas.ternakan_list[b].list_stock,
            max_kuantiti_straw:this.datas.ternakan_list[b].max_kuantiti_straw,
            no_batch_keterangan:this.datas.ternakan_list[b].no_batch_keterangan,
            lkp_penentuan_ai_id:this.datas.ternakan_list[b].lkp_penentuan_ai_id,
            ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
            lkp_kategori_semen_id: this.datas.ternakan_list[b].lkp_kategori_semen_id,
            tarikh_beranak_terdahulu : this.datas.ternakan_list[b].tarikh_beranak_terdahulu,
            baka : this.datas.ternakan_list[b].baka,
            lkpKaedahPemeriksaan_keterangan: this.datas.ternakan_list[b].lkpKaedahPemeriksaan_keterangan,
            lkp_kaedah_pemeriksaan_id: this.datas.ternakan_list[b].lkp_kaedah_pemeriksaan_id,
            bunting_art: this.datas.ternakan_list[b].bunting_art,
            usia_bunting_art: this.datas.ternakan_list[b].usia_bunting_art,
            jankaan_kelahiran_art: this.datas.ternakan_list[b].jankaan_kelahiran_art,
            lkp_status_id:this.datas.ternakan_list[b].lkp_status_id,
            tarikh_lahir_anak:this.datas.ternakan_list[b].tarikh_lahir_anak,
            jantan_anak:this.datas.ternakan_list[b].jantan_anak,
            betina_anak:this.datas.ternakan_list[b].betina_anak,
            jumlah_anak:this.datas.ternakan_list[b].jumlah_anak,
          })
        }
      }
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.ternakan_list, pemeriksaan_kebuntingan:1, hantar:1})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.sinkronisasi_ai.show', this.datas.id));
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
          
          var param = {
            ternakan_list: this.ternakan_list,
            pemeriksaan_kebuntingan:1,
            tarikh_pemeriksaan_art: this.datas.tarikh_pemeriksaan_art,
            konsutasi_pemeriksaan :this.datas.konsutasi_pemeriksaan,
            pengangkutan_pemeriksaan: this.datas.pengangkutan_pemeriksaan,
            keseluruhan_pemeriksaan: this.datas.keseluruhan_pemeriksaan,
            subsidi_pemeriksaan : this.datas.subsidi_pemeriksaan,
            caj_pemeriksaan_pd: this.datas.caj_pemeriksaan_pd,
            perlu_bayar_pemeriksaan : this.datas.perlu_bayar_pemeriksaan,
          }
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, param)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.sinkronisasi_ai.show', this.datas.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
  },
      
  mounted() {
    this.getTernakan();
    // this.datas = this.data;
  }
}
      

</script>  
<style type="text/css">

/*.w-table__row {
  display: flex;
  align-items: center;
}*/
.w-table__cell {
  vertical-align: middle;
}

</style>
